export const lowercaseFirstLetter = (string: string) => {
    return `${string.charAt(0).toLowerCase()}${string.slice(1)}`;
};